export enum ImageSize {
  /** 首页模型 */
  HomeModel = 800,

  /** 详情模型小图 */
  DetailModelSmall = 400,

  /** 详情模型大图 */
  DetailModelLarge = 1200,

  /** 原图大图 */
  OriginalLarge = 2000,

  /** 原图小图 */
  OriginalSmall = 400,

  /** 头像 */
  Avatar = 200,

  /** 打印配置 */
  PrintConfig = 400,

  /** 头像大图 */
  AvatarLarge = 1000,

  /** 评论列表 */
  CommentList = 400,

  /** 轮播图 */
  Carousel = 1000,

  /** 合集 */
  Collection = 800,

  /** 意见反馈 */
  Feedback = 400,

  /** nsfw图片 */
  NSFW = 40,
}

export enum ImageSizeWH {
  /** 首页模型 */
  HomeModel = `&width=${ImageSize.HomeModel}&height=${ImageSize.HomeModel}`,

  /** 首页GIF模型 */
  HomeGifModel = `&width=${ImageSize.HomeModel}&height=${ImageSize.HomeModel}&keepStatic=false`,

  /** 详情模型小图 */
  DetailModelSmall = `&width=${ImageSize.DetailModelSmall}&height=${ImageSize.DetailModelSmall}`,

  /** 详情GIF模型小图 */
  DetailGifModelSmall = `&width=${ImageSize.DetailModelSmall}&height=${ImageSize.DetailModelSmall}&keepStatic=false`,

  /** 详情模型大图 */
  DetailModelLarge = `&width=${ImageSize.DetailModelLarge}&height=${ImageSize.DetailModelLarge}`,

  /** 详情GIF模型大图 */
  DetailGifModelLarge = `&width=${ImageSize.DetailModelLarge}&height=${ImageSize.DetailModelLarge}&keepStatic=false`,

  /** 原图大图 */
  OriginalLarge = `&width=${ImageSize.OriginalLarge}&height=${ImageSize.OriginalLarge}`,

  /** 原图GIF大图 */
  OriginalGifLarge = `&width=${ImageSize.OriginalLarge}&height=${ImageSize.OriginalLarge}&keepStatic=false`,

  /** 原图小图 */
  OriginalSmall = `&width=${ImageSize.OriginalSmall}&height=${ImageSize.OriginalSmall}`,

  /** 原图小图 */
  OriginalGifSmall = `&width=${ImageSize.OriginalSmall}&height=${ImageSize.OriginalSmall}&keepStatic=false`,

  /** 头像 */
  Avatar = `&width=${ImageSize.Avatar}&height=${ImageSize.Avatar}`,

  /** 打印配置 */
  PrintConfig = `&width=${ImageSize.PrintConfig}&height=${ImageSize.PrintConfig}`,

  /** 头像大图 */
  AvatarLarge = `&width=${ImageSize.AvatarLarge}&height=${ImageSize.AvatarLarge}`,

  /** 评论列表 */
  CommentList = `&width=${ImageSize.CommentList}&height=${ImageSize.CommentList}`,

  /** 轮播图 */
  Carousel = `&width=${ImageSize.Carousel}&height=${ImageSize.Carousel}`,

  /** 合集 */
  Collection = `&width=${ImageSize.Collection}&height=${ImageSize.Collection}`,

  /** Gif合集 */
  GifCollection = `&width=${ImageSize.Collection}&height=${ImageSize.Collection}&keepStatic=false`,

  /** nsfw图片 */
  NSFW = `&width=${ImageSize.NSFW}&height=${ImageSize.NSFW}`,

  /** 意见反馈 */
  Feedback = `&width=${ImageSize.Feedback}&height=${ImageSize.Feedback}`,
}
